import { jsx as _jsx } from "react/jsx-runtime";
import { useAttributeState } from './ZigbeeAttributesSlice';
export const ZigbeeAttributeType = (props) => {
    const attr = useAttributeState(props.nid, props.eid, props.cid, props.aid);
    if (attr != undefined) {
        return (_jsx("span", { children: attr.typedValue.type }));
    }
};
